import React from 'react';
import { VscNewFile, VscRefresh } from 'react-icons/vsc';
import AttenteRequete from '../../../hoc/AttenteRequete/AttenteRequete';
import { checkMot } from '../../../ressources/functionJS/checkMot';
import * as type_btn from '../../../ressources/glossaires/glossaire_type_de_bouton';
import Bouton from '../Bouton/Bouton';
import SearchBar from '../SearchBar/SearchBar';
import styles from './Toolbar.module.scss';

const Toolbar = ({
  searchValue,
  onSearchChange,
  onSearchClear,
  searchPlaceholder = 'recherche',
  onRefresh,
  refreshRequestType,
  refreshMessage,
  onCreate,
  createTooltip,
  children,
  className = '',
}) => {
  return (
    <div className={`${styles.toolbar} ${className}`}>
      {/* Search Bar */}
      <SearchBar
        searchValue={searchValue}
        onChange={onSearchChange}
        onClear={onSearchClear}
        placeholder={searchPlaceholder}
      />

      {/* Create Button */}
      {onCreate && (
        <Bouton
          hoverText={createTooltip || checkMot('creer')}
          type={type_btn.outil}
          rond
          cliquer={onCreate}
        >
          <VscNewFile size={15} />
        </Bouton>
      )}

      {/* Refresh Button */}
      {onRefresh && (
        <AttenteRequete
          request_type={refreshRequestType}
          str={refreshMessage || checkMot('requete_en_cours')}
        >
          <Bouton
            hoverText={checkMot('refresh')}
            type={type_btn.outil}
            rond
            cliquer={onRefresh}
          >
            <VscRefresh size={15} />
          </Bouton>
        </AttenteRequete>
      )}

      {/* Additional actions */}
      {children}
    </div>
  );
};

export default Toolbar;
